<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="PARÁMETROS" key="1">
        <a-form-model :model="filterParamsNominaAbierta" v-bind="fiOptions" ref="filterForm">
          <a-row :gutter="[8,8]">
            <a-col v-bind="colOptions">
              <a-form-model-item :label="$t('Empleado')" prop="employee" has-feedback
                                 :rules="[{ required: true, message: 'Valor requerido' }]">
                <form-model-lookup style="width: 100%"
                                   v-model="filterParamsNominaAbierta.employee"
                                   endpoint="empleados">
                </form-model-lookup>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-model-item :label="$t('T. de liquidación')" prop="tipo_liquidacion">
                <form-model-dropdown style="width: 100%"
                                     v-model="filterParamsNominaAbierta.tliq"
                                     endpoint="hierarchy_lookup"
                                     :params="tipo_liq_request"
                ></form-model-dropdown>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-model-item :label="$t('T. de nómina')" prop="tipo_nomina" has-feedback>
                <form-model-dropdown style="width: 100%"
                                     v-model="filterParamsNominaAbierta.tnom"
                                     endpoint="hierarchy_lookup"
                                     :params="tipo_nomina">
                </form-model-dropdown>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-model-item :wrapper-col="{ span: 16 }">
                <a-button type="primary" @click="filtrar">Filtrar</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-tab-pane>
    </a-tabs>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Nómina abierta" key="1">
        <div v-if="!$isEmpty(filterParamsNominaAbierta.employee)">
          {{calcularValores}}
          <g-master :name="masterNominaAbierta.endpoint"
                    :endpoint="masterNominaAbierta.endpoint"
                    :actions="false"
                    :tableSetup="masterNominaAbierta.tableSetup"
                    :parentData="filterParamsNominaAbierta"
                    ref="parentDataNominaAbierta"
                    modalWidth="70%"
                    @params="paramsTable"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <span slot="fechaRenderer" slot-scope="{text}">
                        {{parseDate(text)}}
          </span>
          </g-master>
          <div
            v-if="valoresCalculados.valor_deduccion != null || valoresCalculados.valor_devengo || null && valoresCalculados.valor_otros || null && valoresCalculados.valor_neto || null">
            <a-row :gutter="[8,8]">
              <a-col :xs="12" :md="6">
                <a-statistic title="Valor de deducción" :precision="2"
                             :value="parseFloat(valoresCalculados.valor_deduccion)"/>
              </a-col>
              <a-col :xs="12" :md="6">
                <a-statistic title="Valor de devengo" :precision="2"
                             :value="parseFloat(valoresCalculados.valor_devengo)"/>
              </a-col>
              <a-col :xs="12" :md="6">
                <a-statistic title="Valor de otros" :precision="2" :value="parseFloat(valoresCalculados.valor_otros)"/>
              </a-col>
              <a-col :xs="12" :md="6">
                <a-statistic title="Valor neto" :precision="2" :value="parseFloat(valoresCalculados.valor_neto)"/>
              </a-col>
            </a-row>
          </div>
          <br>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Valores" key="1">
              <div v-if="payVals">
                <a-descriptions bordered :size="'small'">
                  <a-descriptions-item v-if="payVals.pay_num01" :label="payVals.pay_num01">
                    {{payVals.pay_val01}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num02" :label="payVals.pay_num02">
                    {{payVals.pay_val02}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num03" :label="payVals.pay_num03">
                    {{payVals.pay_val03}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num04" :label="payVals.pay_num04">
                    {{payVals.pay_val04}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num05" :label="payVals.pay_num05">
                    {{payVals.pay_val05}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num06" :label="payVals.pay_num06">
                    {{payVals.pay_val06}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num07" :label="payVals.pay_num07">
                    {{payVals.pay_val07}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num08" :label="payVals.pay_num08">
                    {{payVals.pay_val08}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num09" :label="payVals.pay_num09">
                    {{payVals.pay_val09}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num10" :label="payVals.pay_num10">
                    {{payVals.pay_val10}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num11" :label="payVals.pay_num11">
                    {{payVals.pay_val11}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_dat01" :label="payVals.pay_dat01">
                    {{payVals.pay_val12}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_dat02" :label="payVals.pay_dat02">
                    {{payVals.pay_val13}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_dat03" :label="payVals.pay_dat03">
                    {{payVals.pay_val14}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_car01" :label="payVals.pay_car01">
                    {{payVals.pay_val15}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_car02" :label="payVals.pay_car02">
                    {{payVals.pay_val16}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num17" :label="payVals.pay_num17">
                    {{payVals.pay_val17}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num18" :label="payVals.pay_num18">
                    {{payVals.pay_val18}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num19" :label="payVals.pay_num19">
                    {{payVals.pay_val19}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num20" :label="payVals.pay_num20">
                    {{payVals.pay_val20}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num21" :label="payVals.pay_num21">
                    {{payVals.pay_val21}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num22" :label="payVals.pay_num22">
                    {{payVals.pay_val22}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num23" :label="payVals.pay_num23">
                    {{payVals.pay_val23}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num24" :label="payVals.pay_num24">
                    {{payVals.pay_val24}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num25" :label="payVals.pay_num25">
                    {{payVals.pay_val25}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num26" :label="payVals.pay_num26">
                    {{payVals.pay_val26}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num27" :label="payVals.pay_num27">
                    {{payVals.pay_val27}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num28" :label="payVals.pay_num28">
                    {{payVals.pay_val28}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num29" :label="payVals.pay_num29">
                    {{payVals.pay_val29}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payVals.pay_num30" :label="payVals.pay_num30">
                    {{payVals.pay_val30}}
                  </a-descriptions-item>
                </a-descriptions>
                <br>
                <br>
                <br>
              </div>
              <span v-else>Seleccione una nómina para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div v-else>
          Debes seleccionar un empleado para desplegar más información
        </div>
      </a-tab-pane>
      <a-tab-pane tab="Nómina cerrada" key="2">
        <div v-if="!$isEmpty(filterParamsNominaAbierta.employee)">
          <g-master :name="masterNominaCerrada.endpoint"
                    :endpoint="masterNominaCerrada.endpoint"
                    :actions="false"
                    :tableSetup="masterNominaCerrada.tableSetup"
                    :parentData="filterParamsNominaCerrada"
                    ref="masterNominaCerrada"
                    modalWidth="70%"
                    @params="paramsTable"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcelNCerrada" :fileName="fileNameExcelNCerrada"/>
            </template>
          </g-master>
          <br>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Valores" key="1">
              <div v-if="payValsCer">
                <a-descriptions bordered :size="'small'">
                  <a-descriptions-item v-if="payValsCer.pay_num01" :label="payValsCer.pay_num01">
                    {{payValsCer.pay_val01}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num02" :label="payValsCer.pay_num02">
                    {{payValsCer.pay_val02}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num03" :label="payValsCer.pay_num03">
                    {{payValsCer.pay_val03}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num04" :label="payValsCer.pay_num04">
                    {{payValsCer.pay_val04}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num05" :label="payValsCer.pay_num05">
                    {{payValsCer.pay_val05}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num06" :label="payValsCer.pay_num06">
                    {{payValsCer.pay_val06}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num07" :label="payValsCer.pay_num07">
                    {{payValsCer.pay_val07}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num08" :label="payValsCer.pay_num08">
                    {{payValsCer.pay_val08}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num09" :label="payValsCer.pay_num09">
                    {{payValsCer.pay_val09}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num10" :label="payValsCer.pay_num10">
                    {{payValsCer.pay_val10}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num11" :label="payValsCer.pay_num11">
                    {{payValsCer.pay_val11}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_dat01" :label="payValsCer.pay_dat01">
                    {{payValsCer.pay_val12}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_dat02" :label="payValsCer.pay_dat02">
                    {{payValsCer.pay_val13}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_dat03" :label="payValsCer.pay_dat03">
                    {{payValsCer.pay_val14}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_car01" :label="payValsCer.pay_car01">
                    {{payValsCer.pay_val15}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_car02" :label="payValsCer.pay_car02">
                    {{payValsCer.pay_val16}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num17" :label="payValsCer.pay_num17">
                    {{payValsCer.pay_val17}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num18" :label="payValsCer.pay_num18">
                    {{payValsCer.pay_val18}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num19" :label="payValsCer.pay_num19">
                    {{payValsCer.pay_val19}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num20" :label="payValsCer.pay_num20">
                    {{payValsCer.pay_val20}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num21" :label="payValsCer.pay_num21">
                    {{payValsCer.pay_val21}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num22" :label="payValsCer.pay_num22">
                    {{payValsCer.pay_val22}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num23" :label="payValsCer.pay_num23">
                    {{payValsCer.pay_val23}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num24" :label="payValsCer.pay_num24">
                    {{payValsCer.pay_val24}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num25" :label="payValsCer.pay_num25">
                    {{payValsCer.pay_val25}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num26" :label="payValsCer.pay_num26">
                    {{payValsCer.pay_val26}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num27" :label="payValsCer.pay_num27">
                    {{payValsCer.pay_val27}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num28" :label="payValsCer.pay_num28">
                    {{payValsCer.pay_val28}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num29" :label="payValsCer.pay_num29">
                    {{payValsCer.pay_val29}}
                  </a-descriptions-item>
                  <a-descriptions-item v-if="payValsCer.pay_num30" :label="payValsCer.pay_num30">
                    {{payValsCer.pay_val30}}
                  </a-descriptions-item>
                </a-descriptions>
                <br>
                <br>
                <br>
              </div>
              <span v-else>Seleccione una nómina para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div v-else>
          Debes seleccionar un empleado para desplegar más información
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  export default {
    data () {
      return {
        valoresCalculados: {
          valor_base: 0,
          valor_deduccion: 0,
          valor_devengo: 0,
          valor_neto: 0,
          valor_otros: 0
        },
        tipo_liq_request: {
          h_lookup_type: 'TIPO_LIQUIDACION',
          use_code: true
        },
        fileNameExcel: 'nominaAbierta',
        fileNameExcelNCerrada: 'nominaCerrada',
        tipo_nomina: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        paramsT: {},
        endpointExcel: 'payroll_nomina/downloadExcel',
        filterParamsNominaAbierta: {
          tnom: null,
          tliq: null,
          employee: null,
          filter_parent_consulta_nomina_abierta: true
        },
        filterParamsNominaCerrada: {
          tnom: null,
          tliq: null,
          employee: null,
          filter_parent_consulta_nomina_cerrada: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 4},
          'wrapper-col': {span: 16}
        },
        masterNominaAbierta: {
          endpoint: 'payroll',
          tableSetup: {
            customSlots: ['fechaRenderer'],
            actions: false,
            allowSelect: true,
            selectedRows: [{}],
            tableConfig: {
              rowKey: 'id',
              scroll: {x: 3500, y: 300},
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true, width: 400},
              {title: 'Valor', dataIndex: 'ammount', sorter: true},
              {title: 'Unidad', dataIndex: 'und', sorter: true},
              {title: 'Vlr base', dataIndex: 'base', sorter: true},
              {title: 'Vlr de deducción', dataIndex: 'amountded', sorter: true},
              {title: 'Vlr de devengo', dataIndex: 'amountdev', sorter: true},
              {title: 'Vlr otros', dataIndex: 'amountoth', sorter: true},
              {title: 'Valor neto', dataIndex: 'net', sorter: true},
              {title: 'Moneda liq.', dataIndex: 'currency', sorter: true},
              {
                title: 'Fecha de evento',
                dataIndex: 'eventdate',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'fechaRenderer'
                }
              },
              {title: 'Forma de liq.', dataIndex: 'fliq', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Periodo liq', dataIndex: 'periodo_liquidacion', sorter: true},
              {title: 'Proceso', dataIndex: 'desc_proceso', sorter: true}
            ]
          }
        },
        masterNominaCerrada: {
          endpoint: 'payroll',
          tableSetup: {
            actions: false,
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id',
              scroll: {x: 3500, y: 300},
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_disp', sorter: true, width: 400},
              {title: 'Vlr base', dataIndex: 'base', sorter: true},
              {title: 'Unidad', dataIndex: 'und', sorter: true},
              {title: 'Vlr de deducción', dataIndex: 'amountded', sorter: true},
              {title: 'Vlr de devengo', dataIndex: 'amountdev', sorter: true},
              {title: 'Vlr otros', dataIndex: 'amountoth', sorter: true},
              {title: 'Valor neto', dataIndex: 'net', sorter: true},
              {title: 'Moneda liq.', dataIndex: 'currency', sorter: true},
              {
                title: 'Fecha de evento',
                dataIndex: 'eventdate',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'fechaRenderer'
                }
              },
              {title: 'Forma de liq.', dataIndex: 'fliq', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Periodo liq', dataIndex: 'period', sorter: true},
              {title: 'Proceso', dataIndex: 'prc', sorter: true}
            ]
          }
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    computed: {
      calcularValores () {
        this.filterParamsNominaCerrada = {
          employee: this.filterParamsNominaAbierta.employee,
          filter_parent_consulta_nomina_cerrada: true
        }
        this.httpClient.getInstance().post('consulta_payroll/calcular_valores', {
          id_emp: this.filterParamsNominaAbierta.employee
        })
          .then((response) => {
            this.valoresCalculados = response.data
          })
          .catch(() => {
          })
          .then(() => {
          })
      },
      paramsExcel () {
        return {
          ...this.paramsT, ...this.filterParamsNominaAbierta,
          columns: this.masterNominaAbierta.tableSetup.columns
        }
      },
      paramsExcelNCerrada () {
        return {
          ...this.paramsT, ...this.filterParamsNominaCerrada, columns: this.masterNominaCerrada.tableSetup.columns
        }
      },
      payVals () {
        return this.masterNominaAbierta.tableSetup.selectedRows.length > 0 ? this.masterNominaAbierta.tableSetup.selectedRows[0] : null
      },
      payValsCer () {
        return this.masterNominaCerrada.tableSetup.selectedRows.length > 0 ? this.masterNominaCerrada.tableSetup.selectedRows[0] : null
      }
    },
    methods: {
      parseDate (text) {
        return moment(text).format('YYYY-MM-DD')
      },
      paramsTable (params) {
        this.paramsT = params
      },
      filtrar () {
        this.$refs.filterForm.validate(valid => {
          if (valid) {
            this.filterParamsNominaAbierta = {
              employee: this.filterParamsNominaAbierta.employee,
              tnom: this.filterParamsNominaAbierta.tnom,
              tliq: this.filterParamsNominaAbierta.tliq,
              filter_parent_consulta_nomina_abierta: true
            }
            this.filterParamsNominaCerrada = {
              employee: this.filterParamsNominaAbierta.employee,
              tnom: this.filterParamsNominaAbierta.tnom,
              tliq: this.filterParamsNominaAbierta.tliq,
              filter_parent_consulta_nomina_cerrada: true
            }
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ConsultaNomina/NominaAbiertaYCerrada.vue